import styles from './index.module.scss';

interface TextInputProps {
    className?: string;
    title: string;
    name: string;
    placeholder?: string;
    value?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    showLabel?: boolean;
    icon?: string;
}

const TextInput = ({ className, title, name, placeholder, value, onChange, showLabel = true, icon, ...props }: TextInputProps) => {
    return (
        <div className={className}>
            {showLabel && <label htmlFor={name}>{title}</label>}
            <div className={`${styles.inputContainer} ${icon ? styles.withIcon : ''}`}>
                {icon && <img src={icon} alt="search" className={styles.inputIcon} />}
                <input
                    type="text"
                    id={name}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    className={styles.input}
                    {...props}
                />
            </div>
        </div>
    );
};

export default TextInput;
